import { useEffect, useRef } from "react";
import { useGetIdentity } from "ra-core";
import { useQueryClient } from "@tanstack/react-query";
import { effectiveRole } from "../sales/roles";
export function RoleSession() {
  const { identity } = useGetIdentity({
    refetchInterval: 60000,
    refetchOnWindowFocus: true,
  });
  const client = useQueryClient();
  const previous = useRef<string | null>(null);
  const scope = identity
    ? `${identity.id}:${effectiveRole(identity)}:${!!identity.disabled}:${identity.rolesRevision ?? ""}`
    : null;
  useEffect(() => {
    if (!scope) return;
    if (previous.current === null) {
      previous.current = scope;
      localStorage.removeItem("REACT_QUERY_OFFLINE_CACHE");
      return;
    }
    if (previous.current !== scope) {
      previous.current = scope;
      void client.resetQueries({
        predicate: (q) =>
          !(q.queryKey[0] === "auth" && q.queryKey[1] === "getIdentity"),
      });
      localStorage.removeItem("REACT_QUERY_OFFLINE_CACHE");
    }
  }, [scope, client]);
  return null;
}
